/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import PreviewDocumentModal from 'DesignSystem/PreviewDocumentModal/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters/Letter/Actions/EditLetterAction/EditLetterModal/Content"
  
}) {
let letterDocumentNodeIdValueData = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'document_node_id',
})
let letterRecipientIdValueData = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'recipient_id',
})
let onSubmit = fromHelpers.useOnSubmit({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<PreviewDocumentModal
  viewPath={`${viewPath}/PreviewDocumentModal`}
 data="letter.document_node_id"
 documentId={letterDocumentNodeIdValueData}
 onSubmit={onSubmit}
 data="letter.recipient_id"
 defaultRecipientId={letterRecipientIdValueData}
/>
{children}
</React.Fragment>)
}